var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4125 15.2312C10.1125 20.5375 14.4625 24.8687 19.7687 27.5875L23.8937 23.4625C24.4 22.9563 25.15 22.7875 25.8063 23.0125C27.9062 23.7062 30.175 24.0813 32.5 24.0813C33.5312 24.0813 34.375 24.925 34.375 25.9563V32.5C34.375 33.5312 33.5312 34.375 32.5 34.375C14.8937 34.375 0.625 20.1063 0.625 2.5C0.625 1.46875 1.46875 0.625 2.5 0.625H9.0625C10.0938 0.625 10.9375 1.46875 10.9375 2.5C10.9375 4.84375 11.3125 7.09375 12.0062 9.19375C12.2125 9.85 12.0625 10.5813 11.5375 11.1063L7.4125 15.2312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2eef42636f0b9885def6159ca221ff09.svg";
export { ForwardRef as ReactComponent };